export default function searchInternas(){
    $('#search').on('click', function() {
        var keycode = (event.keyCode ? event.keyCode : event.which);
        let rota = $(this).parent().attr('rota');
        let q = $("[name=searchInternas]").val();
        window.location.replace(`${rota}?q=${q}`);
    });
    $('[name=searchInternas]').on('search', function() {
        var keycode = (event.keyCode ? event.keyCode : event.which);
        let rota = $(this).parent().attr('rota');
        let q = $(this).val();
        window.location.replace(`${rota}?q=${q}`);
    });
}
